import { useState, useEffect } from 'react';

export const useWomenCategories = () => {
  const [categories, setCategories] = useState([]);
  const [femmeCategory, setFemmeCategory] = useState(null);
  const [womenSubCategories, setWomenSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/categories`);
      const data = await response.json();

      const allCategories = data.categories || [];

      const femme = allCategories.find(cat => 
        cat.slug === 'femmes' && !cat.parentId
      );

      if (femme) {
        setFemmeCategory(femme);
        const subCats = allCategories.filter(cat => cat.parentId === femme.id);
        
        const filters = [
          { id: 'all', name: 'Toutes les sous-catégories', slug: 'all' },
          ...subCats
        ];

        setWomenSubCategories(filters);
      }

      setCategories(allCategories);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    categories,
    femmeCategory,
    womenSubCategories,
    loading
  };
};
